export default function Button({
  label,
  onClick,
  active = false
}) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: "12px",
        marginTop: "12px",
        borderRadius: "12px",
        background: active
          ? "rgba(255,255,255,0.12)"
          : "transparent",
        border: "1px solid rgba(255,255,255,0.12)",
        color: "white",
        cursor: "pointer",
        transition: "0.2s ease",
        width: "100%"
      }}
    >
      {label}
    </button>
  );
}